import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import GroupItems, { InvalidGroup } from '../group-items'
import ShippingMethods from '../shipping-methods'

export default props => {
    useStyles(classes)
    const { parcels, selectShippingInsuranceHandle, selectShippingMethodHandle, soldoutProducts, multiPack, isOversea, showShippingMethod, setShowShippingMethod } = props


    return <div className={`${classes.Groups} ${parcels?.length === 1 ? classes.Single : ''}`}>
        {
            parcels?.length > 0 && <>
                {
                    parcels.map((parcel, index) => <div key={index} className={classes.Group}>
                        <GroupItems itemCount={parcel.totalCount} showIndex={parcels?.length > 1} parcelIndex={index + 1} title={parcel.title} billingProducts={parcel.billingProducts} />

                        {
                            (index === parcels.length - 1 && soldoutProducts?.length > 0) && <InvalidGroup soldoutProducts={soldoutProducts} />
                        }

                        {
                            multiPack && <ShippingMethods
                            shippingInsuranceMsg={parcel.shippingInsuranceMsg}
                            shippingMethods={parcel.shippingMethods}
                            preOrderShippingMethods={parcel.preOrderShippingMethods}
                            useShippingInsurance={parcel.useShippingInsurance}
                            expectedShippingInsurance={parcel.expectedShippingInsurance}
                            onShippingMethod={shippingMethod => selectShippingMethodHandle({
                                shippingMethodId: shippingMethod?.id,
                                shipsFrom: parcel.shipsFrom
                            })}
                            onInsurance={value => selectShippingInsuranceHandle({
                                useShippingInsurance: value,
                                shipsFrom: parcel.shipsFrom
                            })}
                            isOversea={parcel?.shipsFrom == 'Overseas'}
                            preOrderItemCount={parcel.preOrderItemCount}
                            itemCount={parcel.itemCount}
                            />
                        }
                    </div>)
                }

            </>
        }

        {
            (parcels?.length <= 0 || !parcels) && soldoutProducts?.length > 0 && <div className={classes.Group}>
                <InvalidGroup soldoutProducts={soldoutProducts} />
            </div>
        }
    </div>
}